import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Delimiter.module.scss';

type DelimiterProps = {
  mode?: "fade" | "block"
};

const Delimiter: React.FC<DelimiterProps> = ({mode = "fade"}) => {
  return <div className={classNames(styles.delimiter, styles[mode])}></div>;
};

Delimiter.propTypes = {
  mode: PropTypes.oneOf(["fade", "block"]),
};

export default Delimiter;
